export default {
  panelIsVisible: true,
  listIsVisible: false,
  mobileCardIsVisilbe: false,
}
